import React from 'react';
import BaseOverride from 'Views/Page/Content/Templates/BaseOverride';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import ApexFundingAccountUnlinkContent from './Content';

const Layout = () => {
  const { pageContentResource: resource } = usePageContentContext();

  return (
    <WizardStepWrapperTemplate
      resource={resource}
      layout={ApexFundingAccountUnlinkContent}
      primaryActionLabel="Break Connection"
      LayoutProps={{
        resource,
      }}
      metaOverrideSet={BaseOverride}
      hideErrors
    />
  );
};

export default Layout;
